  // List of mathematical theorems, inequalities and lemmas
  // Sourced from
  // https://en.wikipedia.org/wiki/List_of_theorems
  // https://en.wikipedia.org/wiki/List_of_lemmas
  // https://en.wikipedia.org/wiki/List_of_inequalities
  // https://en.wikipedia.org/wiki/List_of_fundamental_theorems
var list = [
    "15 and 290 theorems",
    "AF+BG theorem",
    "Abel's binomial theorem",
    "Abel's theorem",
    "Abelian and tauberian theorems",
    "Abel–Ruffini theorem",
    "Absolute convergence theorem",
    "Acyclic models theorem",
    "Adiabatic theorem",
    "Ahiezer's theorem",
    "Albert–Brauer–Hasse–Noether theorem",
    "Alperin–Brauer–Gorenstein theorem",
    "Amitsur–Levitzki theorem",
    "Anderson's theorem",
    "Angle bisector theorem",
    "Anne's theorem",
    "Appell–Humbert theorem",
    "Apéry's theorem",
    "Arithmetic Riemann–Roch theorem",
    "Aronszajn–Smith theorem",
    "Arrow's impossibility theorem",
    "Artin approximation theorem",
    "Artin–Wedderburn theorem",
    "Artstein's theorem",
    "Atiyah–Bott fixed-point theorem",
    "Atiyah–Singer index theorem",
    "Aumann's agreement theorem",
    "Auxiliary polynomial theorem",
    "Ax–Kochen theorem",
    "BEST theorem",
    "Babuška–Lax–Milgram theorem",
    "Baire category theorem",
    "Balinski's theorem",
    "Banach fixed-point theorem",
    "Banach–Mazur theorem",
    "Banach–Stone theorem",
    "Baranyai's theorem",
    "Barban–Davenport–Halberstam theorem",
    "Barwise compactness theorem",
    "Basu's theorem",
    "Bayes' theorem",
    "Beauville–Laszlo theorem",
    "Beck's theorem (geometry)",
    "Beckman–Quarles theorem",
    "Behnke–Stein theorem",
    "Beltrami's theorem",
    "Bendixson–Dulac theorem",
    "Berger–Kazdan comparison theorem",
    "Berry–Esséen theorem",
    "Bertrand's ballot theorem",
    "Bertrand–Diquet–Puiseux theorem",
    "Betti's theorem",
    "Bing's recognition theorem",
    "Binomial inverse theorem",
    "Birch's theorem",
    "Birkhoff's ergodic theorem",
    "Birkhoff's theorem (relativity)",
    "Birkhoff–Grothendieck theorem",
    "Bishop–Cannings theorem",
    "Bloch's theorem (complex variables)",
    "Blum's speedup theorem",
    "Bohr–Mollerup theorem",
    "Bolyai–Gerwien theorem",
    "Bolzano–Weierstrass theorem",
    "Bombieri–Friedlander–Iwaniec theorem",
    "Bondy's theorem",
    "Bonnet theorem",
    "Boolean prime ideal theorem",
    "Borel fixed-point theorem",
    "Borel–Carathéodory theorem",
    "Borsuk–Ulam theorem",
    "Bounded convergence theorem",
    "Bourbaki–Witt theorem",
    "Branching theorem",
    "Brauer's theorem on induced characters",
    "Brauer's three main theorems",
    "Brauer–Nesbitt theorem",
    "Brauer–Suzuki theorem",
    "Brianchon's theorem",
    "Brooks's theorem",
    "Brouwer fixed-point theorem",
    "Brown's representability theorem",
    "Brun's theorem",
    "Brunn–Minkowski theorem",
    "Buckingham π theorem",
    "Burnside's theorem",
    "Butterfly theorem",
    "Bôcher's theorem",
    "Cameron–Martin theorem",
    "Cantor's intersection theorem",
    "Cantor's theorem",
    "Cantor–Bernstein–Schroeder theorem",
    "Carathéodory's extension theorem",
    "Carathéodory's theorem (convex hull)",
    "Carathéodory–Jacobi–Lie theorem",
    "Caristi fixed-point theorem",
    "Carlson's theorem",
    "Carnot's theorem (inradius, circumradius)",
    "Cartan's theorems A and B",
    "Cartan–Dieudonné theorem",
    "Cartan–Kuranishi prolongation theorem",
    "Casey's theorem",
    "Castelnuovo–de Franchis theorem",
    "Cauchy's theorem (geometry)",
    "Cauchy integral theorem",
    "Cauchy–Kowalevski theorem",
    "Cayley–Salmon theorem",
    "Central limit theorem",
    "Ceva's theorem",
    "Chebotarev's density theorem",
    "Cheng's eigenvalue comparison theorem",
    "Chevalley's structure theorem",
    "Chevalley–Warning theorem",
    "Chinese remainder theorem",
    "Choi's theorem on completely positive maps",
    "Chomsky–Schützenberger enumeration theorem",
    "Choquet–Bishop–de Leeuw theorem",
    "Church–Rosser theorem",
    "Clairaut's theorem",
    "Clark–Ocone theorem",
    "Clausius theorem",
    "Clifford's circle theorems",
    "Closed graph theorem",
    "Closed subgroup theorem",
    "Coase theorem",
    "Codd's theorem",
    "Cohen structure theorem",
    "Coleman–Mandula theorem",
    "Commandino's theorem",
    "Compactness theorem",
    "Compression theorem",
    "Conley–Zehnder theorem",
    "Constant chord theorem",
    "Continuous mapping theorem",
    "Convolution theorem",
    "Corners theorem",
    "Courcelle's theorem",
    "Craig's theorem",
    "Cramer's theorem (algebraic curves)",
    "Cramér–Wold theorem",
    "Cramér’s decomposition theorem",
    "Crooks fluctuation theorem",
    "Crystallographic restriction theorem",
    "Curtis–Hedlund–Lyndon theorem",
    "Cybenko theorem",
    "Danskin's theorem",
    "Darboux's theorem (analysis)",
    "Davenport–Schmidt theorem",
    "De Branges's theorem",
    "De Bruijn–Erdős theorem (graph theory)",
    "De Finetti's theorem",
    "De Gua's theorem",
    "De Rham's theorem",
    "Denjoy–Carleman theorem",
    "Desargues's theorem",
    "Diller–Dress theorem",
    "Dimension theorem for vector spaces",
    "Dini's theorem",
    "Dinostratus' theorem",
    "Dirac's theorem on chordal graphs",
    "Dirichlet's approximation theorem",
    "Dirichlet's unit theorem",
    "Disintegration theorem",
    "Dominated convergence theorem",
    "Donsker's theorem",
    "Doob's martingale convergence theorems",
    "Doob–Meyer decomposition theorem",
    "Dudley's theorem",
    "Dunford–Pettis theorem",
    "Earnshaw's theorem",
    "Eberlein–Šmulian theorem",
    "Edge-of-the-wedge theorem",
    "Egorov's theorem",
    "Eilenberg–Zilber theorem",
    "Elitzur's theorem",
    "Envelope theorem",
    "Equidistribution theorem",
    "Erdős–Anning theorem",
    "Erdős–Dushnik–Miller theorem",
    "Erdős–Ginzburg–Ziv theorem",
    "Erdős–Ko–Rado theorem",
    "Erdős–Pósa theorem",
    "Erdős–Stone theorem",
    "Euclid's theorem",
    "Euclid–Euler theorem",
    "Euler's quadrilateral theorem",
    "Euler's theorem",
    "Euler's theorem in geometry",
    "Exchange theorem",
    "Exterior angle theorem",
    "Extreme value theorem",
    "F. and M. Riesz theorem",
    "Faltings's theorem",
    "Farrell–Markushevich theorem",
    "Fatou–Lebesgue theorem",
    "Feit–Thompson theorem",
    "Fenchel's theorem",
    "Fermat's little theorem",
    "Fermat's last theorem",
    "Fermat's theorem on sums of two squares",
    "Fermat polygonal number theorem",
    "Ferrero–Washington theorem",
    "Fieller's theorem",
    "Finsler–Hadwiger theorem",
    "Fisher–Tippett–Gnedenko theorem",
    "Five circles theorem",
    "Fixed-point theorems in infinite-dimensional spaces",
    "Fluctuation dissipation theorem",
    "Focal subgroup theorem",
    "Foster's theorem",
    "Four color theorem",
    "Fourier inversion theorem",
    "Fraňková–Helly selection theorem",
    "Freidlin–Wentzell theorem",
    "Freudenthal suspension theorem",
    "Frobenius determinant theorem",
    "Frobenius theorem (differential topology)",
    "Froda's theorem",
    "Fubini's theorem",
    "Fuchs's theorem",
    "Full employment theorem",
    "Fulton–Hansen connectedness theorem",
    "Fundamental theorem of algebra",
    "Fundamental theorem of arithmetic",
    "Fundamental theorem on homomorphisms",
    "Fundamental theorem of Galois theory",
    "Fáry's theorem",
    "Gauss theorem",
    "Gauss–Lucas theorem",
    "Gauss–Wantzel theorem",
    "Gelfand–Naimark theorem",
    "Geometric mean theorem",
    "Gershgorin circle theorem",
    "Generalized Stokes theorem",
    "Girsanov's theorem",
    "Gleason's theorem",
    "Glivenko–Cantelli theorem",
    "Godunov's theorem",
    "Goldberg–Sachs theorem",
    "Goldstine theorem",
    "Golod–Shafarevich theorem",
    "Goodstein's theorem",
    "Gottesman–Knill theorem",
    "Graph structure theorem",
    "Grauert–Riemenschneider vanishing theorem",
    "Green's theorem",
    "Grinberg's theorem",
    "Gromov's compactness theorem (geometry)",
    "Gromov's theorem on groups of polynomial growth",
    "Gross–Zagier theorem",
    "Grothendieck's connectedness theorem",
    "Grothendieck–Hirzebruch–Riemann–Roch theorem",
    "Grunsky's theorem",
    "Grushko theorem",
    "Gödel's completeness theorem",
    "H-cobordism theorem",
    "Haag's theorem",
    "Haag–Łopuszański–Sohnius theorem",
    "Hadamard three-circle theorem",
    "Hadwiger's theorem",
    "Hahn decomposition theorem",
    "Hahn–Banach theorem",
    "Hahn–Mazurkiewicz theorem",
    "Hajnal–Szemerédi theorem",
    "Hall's marriage theorem",
    "Hairy ball theorem",
    "Ham sandwich theorem",
    "Hardy's theorem",
    "Hardy–Littlewood maximal theorem",
    "Hardy–Ramanujan theorem",
    "Harish–Chandra's regularity theorem",
    "Harnack's curve theorem",
    "Hartman–Grobman theorem",
    "Hartogs's theorem",
    "Hartogs–Rosenthal theorem",
    "Schneider–Lang theorem",
    "Hasse's theorem on elliptic curves",
    "Hasse–Minkowski theorem",
    "Heine–Borel theorem",
    "Hellinger–Toeplitz theorem",
    "Helly's selection theorem",
    "Helly–Bray theorem",
    "Helmholtz theorem (classical mechanics)",
    "Herbrand–Ribet theorem",
    "Hilbert's basis theorem",
    "Hilbert's irreducibility theorem",
    "Hilbert's theorem (differential geometry)",
    "Hilbert projection theorem",
    "Hilbert–Speiser theorem",
    "Hille–Yosida theorem",
    "Hinge theorem",
    "Hirzebruch signature theorem",
    "Hjelmslev's theorem",
    "Hodge index theorem",
    "Holditch's theorem",
    "Holmström's theorem",
    "Hurewicz theorem",
    "Hurwitz's automorphisms theorem",
    "Hurwitz's theorem (normed division algebras)",
    "Hölder's theorem",
    "Identity theorem for Riemann surfaces",
    "Immerman–Szelepcsényi theorem",
    "Increment theorem",
    "Initial value theorem",
    "Integral representation theorem for classical Wiener space",
    "Intercept theorem",
    "Intermediate value theorem",
    "Intersecting secants theorem",
    "Inverse eigenvalues theorem",
    "Ionescu-Tulcea theorem",
    "Isomorphism theorem",
    "Jackson's theorem (queueing theory)",
    "Jacobi's four-square theorem",
    "Jacobson–Bourbaki theorem",
    "Japanese theorem for concyclic polygons",
    "Jordan's theorem (multiply transitive groups)",
    "Jordan curve theorem",
    "Jordan–Schur theorem",
    "Joubert's theorem",
    "Jurkat–Richert theorem",
    "Kanamori–McAloon theorem",
    "Kaplansky's theorem on quadratic forms",
    "Karhunen–Loève theorem",
    "Katz–Lang finiteness theorem",
    "Kawasaki's theorem",
    "Kelvin's circulation theorem",
    "Kharitonov's theorem",
    "Killing–Hopf theorem",
    "Kirchhoff's theorem",
    "Kleene's recursion theorem",
    "Knaster–Tarski theorem",
    "Kneser's theorem (differential equations)",
    "Kodaira embedding theorem",
    "Koebe 1/4 theorem",
    "Kolmogorov's three-series theorem",
    "Kolmogorov–Arnold representation theorem",
    "Kraft–McMillan theorem",
    "Krein–Milman theorem",
    "Kronecker's theorem",
    "Krull's principal ideal theorem",
    "Kruskal's tree theorem",
    "Krylov–Bogolyubov theorem",
    "Kuiper's theorem",
    "Kutta–Joukowski theorem",
    "König's theorem (set theory)",
    "Kövari–Sós–Turán theorem",
    "Kōmura's theorem",
    "L-balance theorem",
    "Lafforgue's theorem",
    "Lagrange's four-square theorem",
    "Lagrange's theorem (number theory)",
    "Lagrange inversion theorem",
    "Lambek–Moser theorem",
    "Landau prime ideal theorem",
    "Lattice theorem",
    "Laurent expansion theorem",
    "Lax–Milgram theorem",
    "Lax–Wendroff theorem",
    "Lebesgue's decomposition theorem",
    "Lebesgue differentiation theorem",
    "Lee–Yang theorem",
    "Lefschetz fixed-point theorem",
    "Lefschetz theorem on (1,1)-classes",
    "Lehmann–Scheffé theorem",
    "Leray–Hirsch theorem",
    "Lester's theorem",
    "Levitzky's theorem",
    "Lickorish–Wallace theorem",
    "Lie's third theorem",
    "Lie–Kolchin theorem",
    "Lindelöf's theorem",
    "Lindemann–Weierstrass theorem",
    "Linear congruence theorem",
    "Linnik's theorem",
    "Lions–Lax–Milgram theorem",
    "Liouville's theorem (complex analysis)",
    "Liénard's theorem",
    "Lochs's theorem",
    "Looman–Menchoff theorem",
    "Lukacs's proportion-sum independence theorem",
    "Luzin's theorem",
    "Lyapunov's central limit theorem",
    "Lévy's modulus of continuity theorem",
    "Löb's theorem",
    "Löwenheim–Skolem theorem",
    "MacMahon Master theorem",
    "Mahler's theorem",
    "Malgrange preparation theorem",
    "Manin–Drinfeld theorem",
    "Marcinkiewicz theorem",
    "Marginal value theorem",
    "Martingale representation theorem",
    "Mason–Stothers theorem",
    "Matiyasevich's theorem",
    "Maximal ergodic theorem",
    "Maxwell's theorem",
    "Mazur's control theorem",
    "Mazur–Ulam theorem",
    "Mean value theorem",
    "Mellin inversion theorem",
    "Menger's theorem",
    "Mergelyan's theorem",
    "Mertens's theorems",
    "Meusnier's theorem",
    "Mihăilescu's theorem",
    "Milliken–Taylor theorem",
    "Min-max theorem",
    "Minkowski's second theorem",
    "Minkowski–Hlawka theorem",
    "Miquel's theorem",
    "Mitchell's embedding theorem",
    "Modigliani–Miller theorem",
    "Modularity theorem",
    "Monge's theorem",
    "Monotone class theorem",
    "Montel's theorem",
    "Mordell–Weil theorem",
    "Morera's theorem",
    "Morley's categoricity theorem",
    "Morton's theorem",
    "Mountain pass theorem",
    "Multinomial theorem",
    "Multiplicity-one theorem",
    "Mutual fund separation theorem",
    "Myers theorem",
    "Myhill–Nerode theorem",
    "Nachbin's theorem",
    "Nagata's compactification theorem",
    "Nagell–Lutz theorem",
    "Nash embedding theorem",
    "Newlander–Niremberg theorem",
    "Newton's theorem about ovals",
    "Nielsen fixed-point theorem",
    "Nielsen–Schreier theorem",
    "No-broadcast theorem",
    "No-communication theorem",
    "No-trade theorem",
    "No wandering domain theorem",
    "Noether's theorem",
    "Noisy channel coding theorem",
    "Norton's theorem",
    "Novikov's compact leaf theorem",
    "Nyquist–Shannon sampling theorem",
    "Open mapping theorem (complex analysis)",
    "Optical equivalence theorem",
    "Orbit-stabilizer theorem",
    "Ore's theorem",
    "Orlicz–Pettis theorem",
    "Oseledec theorem",
    "Osterwalder–Schrader theorem",
    "Ostrowski–Hadamard gap theorem",
    "PCP theorem",
    "Paley–Wiener theorem",
    "Pappus's area theorem",
    "Pappus's hexagon theorem",
    "Paris–Harrington theorem",
    "Parseval's theorem",
    "Pascal's theorem",
    "Peano existence theorem",
    "Peixoto's theorem",
    "Penrose–Hawking singularity theorems",
    "Perfect graph theorem",
    "Perpendicular axis theorem",
    "Peter–Weyl theorem",
    "Phragmén–Lindelöf theorem",
    "Picard–Lindelöf theorem",
    "Pickands–Balkema–de Haan theorem",
    "Pitot theorem",
    "Planar separator theorem",
    "Plancherel theorem for spherical functions",
    "Poincaré recurrence theorem",
    "Poincaré–Birkhoff–Witt theorem",
    "Poisson limit theorem",
    "Pompeiu's theorem",
    "Poncelet's closure theorem",
    "Positive energy theorem",
    "Poynting's theorem",
    "Prime number theorem",
    "Principal axis theorem",
    "Prokhorov's theorem",
    "Proth's theorem",
    "Pseudorandom generator theorem",
    "Pythagorean theorem",
    "Quantum threshold theorem",
    "Quillen–Suslin theorem",
    "Rademacher's theorem",
    "Radon–Nikodym theorem",
    "Raikov's theorem",
    "Ramanujam vanishing theorem",
    "Ramsey's theorem",
    "Rao–Blackwell theorem",
    "Rationality theorem",
    "Rauch comparison theorem",
    "Reeb sphere theorem",
    "Reflection theorem",
    "Reider's theorem",
    "Residue theorem",
    "Reversed compound agent theorem",
    "Ribet's theorem",
    "Rice–Shapiro theorem",
    "Riemann's existence theorem",
    "Riemann mapping theorem",
    "Riemann singularity theorem",
    "Riemann–Roch theorem",
    "Riemann–Roch theorem for surfaces",
    "Riesz representation theorem",
    "Riesz–Thorin theorem",
    "Robbins theorem",
    "Robertson–Seymour theorem",
    "Robinson's joint consistency theorem",
    "Rolle's theorem",
    "Rouché's theorem",
    "Routh's theorem",
    "Runge's theorem",
    "Ryll-Nardzewski fixed-point theorem",
    "S-cobordism theorem",
    "Sahlqvist correspondence theorem",
    "Sard's theorem",
    "Savitch's theorem",
    "Schaefer's dichotomy theorem",
    "Schilder's theorem",
    "Schreier refinement theorem",
    "Schröder–Bernstein theorems for operator algebras",
    "Schur's theorem",
    "Schur–Zassenhaus theorem",
    "Schwartz–Zippel theorem",
    "Schwenk's theorem",
    "Seifert–van Kampen theorem",
    "Separating axis theorem",
    "Shannon's source coding theorem",
    "Shell theorem",
    "Shirshov–Cohn theorem",
    "Siegel–Walfisz theorem",
    "Simplicial approximation theorem",
    "Sinkhorn's theorem",
    "Sipser–Lautemann theorem",
    "Six circles theorem",
    "Łoś' theorem",
    "Six exponentials theorem",
    "Skoda–El Mir theorem",
    "Skolem–Noether theorem",
    "Skorokhod's representation theorem",
    "Smn theorem",
    "Sobolev embedding theorem",
    "Sonnenschein–Mantel–Debreu Theorem",
    "Soul theorem",
    "Space hierarchy theorem",
    "Spectral theorem",
    "Sphere theorem",
    "Spin–statistics theorem",
    "Squeeze theorem",
    "Stallings theorem about ends of groups",
    "Stanley's reciprocity theorem",
    "Stark–Heegner theorem",
    "Steinhaus theorem",
    "Stein–Strömberg theorem",
    "Stinespring factorization theorem",
    "Stokes' theorem",
    "Stolper–Samuelson theorem",
    "Stone's representation theorem for Boolean algebras",
    "Stone–Tukey theorem",
    "Stone–von Neumann theorem",
    "Strong perfect graph theorem",
    "Structure theorem for finitely generated modules over a principal ideal domain",
    "Structured program theorem",
    "Sturm–Picone comparison theorem",
    "Supporting hyperplane theorem",
    "Sylow theorems",
    "Sylvester's determinant theorem",
    "Sylvester pentahedral theorem",
    "Symmetric hypergraph theorem",
    "Sz.-Nagy's dilation theorem",
    "Szemerédi's theorem",
    "Szpilrajn extension theorem",
    "Takens's theorem",
    "Tangent-secant theorem",
    "Tarski's indefinability theorem",
    "Taylor–Proudman theorem",
    "Thales's theorem",
    "Thompson transitivity theorem",
    "Thomsen's theorem",
    "Thue–Siegel–Roth theorem",
    "Thévenin's theorem",
    "Tijdeman's theorem",
    "Tikhonov fixed-point theorem",
    "Titchmarsh convolution theorem",
    "Toda's theorem",
    "Tonelli's theorem (functional analysis)",
    "Toponogov's theorem",
    "Trichotomy theorem",
    "Trombi–Varadarajan theorem",
    "Tsen's theorem",
    "Turán's theorem",
    "Tutte theorem",
    "Ugly duckling theorem",
    "Universal approximation theorem",
    "Unmixedness theorem",
    "Van Aubel's theorem",
    "Van der Waerden's theorem",
    "Varignon's theorem",
    "Vietoris–Begle mapping theorem",
    "Virial theorem",
    "Vitali convergence theorem",
    "Vitali–Hahn–Saks theorem",
    "Von Neumann's theorem",
    "Von Neumann bicommutant theorem",
    "Wagner's theorem",
    "Weber's theorem",
    "Wedderburn's little theorem",
    "Weierstrass preparation theorem",
    "Weinberg–Witten theorem",
    "Whitehead theorem",
    "Whitney embedding theorem",
    "Whitney immersion theorem",
    "Wiener's tauberian theorem",
    "Wigner–Eckart theorem",
    "Wilson's theorem",
    "Wold's theorem",
    "Wolstenholme's theorem",
    "ZJ theorem",
    "Zariski's main theorem",
    "Zeilberger–Bressoud theorem",
    "Śleszyński–Pringsheim theorem",
    "Birkhoff's representation theorem",
    "Fundamental theorem of Riemannian geometry",
    "Fundamental theorem of algebraic K-theory",
    "Fundamental theorem of curves",
    "Fundamental theorem of exterior calculus",
    "Fundamental theorem of ideal theory in number fields",
    "Fundamental theorem of linear programming",
    "Fundamental theorem of projective geometry",
    "Fundamental theorem of topos theory",
    "Fundamental theorem on homomorphisms",
    "Glivenko–Cantelli theorem",
    "Hammersley–Clifford theorem",
    "Main theorem of elimination theory",
    "Structure theorem for finitely generated modules over a principal ideal domain",
    "Abhyankar's lemma",
    "Artin–Rees lemma",
    "Berge's lemma",
    "Borel–Cantelli lemma",
    "Burnside's lemma",
    "Cotlar–Stein lemma",
    "Covering lemma",
    "Céa's lemma",
    "Delta lemma",
    "Dickson's lemma",
    "Doob–Dynkin lemma",
    "Ehrling's lemma",
    "Ellis–Numakura lemma",
    "Euclid's lemma",
    "Expander mixing lemma",
    "Farkas's lemma",
    "Finsler's lemma",
    "Five lemma",
    "Fixed-point lemma for normal functions",
    "Fodor's lemma",
    "Frostman's lemma",
    "Fundamental lemma (Langlands program)",
    "Fundamental lemma of sieve theory",
    "Glivenko–Cantelli lemma",
    "Hartogs's lemma",
    "Higman's lemma",
    "Hopf lemma",
    "Hotelling's lemma",
    "Itô's lemma",
    "Johnson–Lindenstrauss lemma",
    "Kalman–Yakubovich–Popov lemma",
    "Knaster–Kuratowski–Mazurkiewicz lemma",
    "Kronecker's lemma",
    "Krull's separation lemma",
    "Lax–Milgram lemma",
    "Lebesgue's number lemma",
    "Lindelöf's lemma",
    "Little's lemma",
    "Lovász local lemma",
    "Malliavin's absolute continuity lemma",
    "Matrix determinant lemma",
    "Moschovakis coding lemma",
    "Nakayama lemma",
    "Neyman–Pearson lemma",
    "Noether's normalization lemma",
    "Ogden's lemma",
    "Piling-up lemma",
    "Poincaré lemma",
    "Prime avoidance lemma",
    "Pugh's closing lemma",
    "Pólya–Burnside lemma",
    "Rasiowa–Sikorski lemma",
    "Riemann–Lebesgue lemma",
    "Robbins lemma",
    "Schanuel's lemma",
    "Schreier's subgroup lemma",
    "Schwartz–Zippel lemma and testing polynomial identities",
    "Shadowing lemma",
    "Short five lemma",
    "Snake lemma",
    "Splitting lemma",
    "Stechkin's lemma",
    "Stewart–Walker lemma",
    "Switching lemma",
    "Szemerédi regularity lemma",
    "Tube lemma",
    "Ultrafilter lemma",
    "Vaughan's lemma",
    "Vitali covering lemma",
    "Watson's lemma",
    "Whitehead's lemma",
    "Yao's XOR lemma",
    "Yoneda lemma",
    "Zolotarev's lemma",
    "Abel's inequality",
    "Agmon's inequality",
    "Alexandrov–Fenchel inequality",
    "Aristarchus's inequality",
    "Azuma's inequality",
    "Barrow's inequality",
    "Bell's theorem",
    "Bennett's inequality",
    "Berger–Kazdan comparison theorem",
    "Bernstein's inequality (mathematical analysis)",
    "Bessel's inequality",
    "Bihari–LaSalle inequality",
    "Bishop–Gromov inequality",
    "Blaschke–Santaló inequality",
    "Bonnesen's inequality",
    "Boole's inequality",
    "Borell–Brascamp–Lieb inequality",
    "Brascamp–Lieb inequality",
    "Brezis–Gallouet inequality",
    "CHSH inequality",
    "Carleman's inequality",
    "Cauchy–Schwarz inequality",
    "Chebyshev's inequality",
    "Chebyshev's sum inequality",
    "Cheng's eigenvalue comparison theorem",
    "Chung–Erdős inequality",
    "Clausius–Duhem inequality",
    "Cohn-Vossen's inequality",
    "Comparison theorem",
    "Correlation inequality",
    "Doob's martingale inequality",
    "Eaton's inequality",
    "Entropy power inequality",
    "Etemadi's inequality",
    "FKG inequality",
    "Fannes–Audenaert inequality",
    "Fekete–Szegő inequality",
    "Fisher's inequality",
    "Gagliardo–Nirenberg interpolation inequality",
    "Gaussian correlation inequality",
    "Gauss–Markov theorem",
    "Gibbs's inequality",
    "Golden–Thompson inequality",
    "Gromov's inequality for complex projective space",
    "Grothendieck inequality",
    "Grönwall's inequality",
    "Hadamard's inequality",
    "Hardy's inequality",
    "Hardy–Littlewood maximal inequality",
    "Harnack's inequality",
    "Heisenberg's inequality",
    "Hilbert's inequality",
    "Hitchin–Thorpe inequality",
    "Holley inequality",
    "Ingleton's inequality",
    "Jackson's inequality",
    "Jordan's inequality",
    "Kantorovich inequality",
    "Khintchine inequality",
    "Korn's inequality",
    "Kunita–Watanabe inequality",
    "Ladyzhenskaya's inequality",
    "Large sieve inequality",
    "Lebedev–Milin inequality",
    "Lenglart's inequality",
    "Lieb–Thirring inequality",
    "Littlewood's 4/3 inequality",
    "Loewner's torus inequality",
    "Loomis–Whitney inequality",
    "Lubell–Yamamoto–Meshalkin inequality",
    "Mahler's inequality",
    "Marcinkiewicz–Zygmund inequality",
    "Markov brothers' inequality",
    "Max–min inequality",
    "Milman's reverse Brunn–Minkowski inequality",
    "Minkowski's first inequality for convex bodies",
    "Muirhead's inequality",
    "Nesbitt's inequality",
    "Noether inequality",
    "Ono's inequality",
    "Pedoe's inequality",
    "Pinsker's inequality",
    "Poincaré inequality",
    "Poincaré separation theorem",
    "Popoviciu's inequality on variances",
    "Prékopa–Leindler inequality",
    "Pu's inequality",
    "Pólya–Vinogradov inequality",
    "Rayleigh–Faber–Krahn inequality",
    "Remez inequality",
    "Riemannian Penrose inequality",
    "Rushbrooke inequality",
    "Schur's inequality",
    "Shapiro inequality",
    "Sobolev inequality",
    "Steffensen's inequality",
    "Stochastic Gronwall inequality",
    "Sylvester–Gallai theorem",
    "Talagrand's concentration inequality",
    "Toponogov's theorem",
    "Triangle inequality",
    "Tsirelson's inequality",
    "Turán–Kubilius inequality",
    "Vitale's random Brunn–Minkowski inequality",
    "Vysochanskiï–Petunin inequality",
    "Weyl's inequality",
    "Wirtinger inequality (2-forms)",
    "Young's convolution inequality",
    "Łojasiewicz inequality",
    "Hoffman-Wielandt inequality",
    "Emery's inequality",
  ];

  export var list;